<template>
  <div class="walls">
    <div style="display: none;">
      <abacus-helper
          v-for="i in rods"
          :key="'upper_'.concat(i)"
          :rod=i
          deck="upper"

          @obsoleteDeckRod="clearDeckRod($event);"
      >
      </abacus-helper>

      <abacus-helper
          v-for="i in rods"
          :key="'lower_'.concat(i)"
          :rod=i
          deck="lower"

          @obsoleteDeckRod="clearDeckRod($event);"
      >
      </abacus-helper>
    </div>

    <div class="upper">
      <vue-slider
          v-model="abacus.upper[i-1]"
          v-for="i in rods"
          :key="i"
          :ref="'upper'.concat(i)"
          direction="ttb"
          height="80%"
          dot-size="60"
          :contained="true"
          :tooltip="'none'"
          :max="limits.upper"
          :interval="1"
          :marks="true"
          :hide-label="true"
          :lazy="true"

      ></vue-slider>
    </div>

    <div class="bar">
      <vue-slider
          v-model="abacus.bar"
          dot-size="25"
          direction="rtl"
          :contained="true"
          :tooltip="'none'"
          :marks="true"
          :hide-label="true"
          :lazy="true"
          :min="0"
          :max=rods
      ></vue-slider>
    </div>

    <div class="lower">
      <vue-slider
          v-model="abacus.lower[i-1]"
          v-for="i in rods"
          :key="i"
          :ref="'lower'.concat(i)"
          direction="btt"
          height="100%"
          dot-size="60"
          :contained="true"
          :tooltip="'none'"
          :marks="true"
          :hide-label="true"
          :max="limits.lower"
          :interval="1"
          :lazy="true"
      ></vue-slider>
    </div>

  </div>
</template>

<script>
// App.vue
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import AbacusHelper from "@/x-html/AbacusHelper";
import {mapGetters} from 'vuex'

export default {
  props: {
    rods: {
      type: Number,
      default: 5
    }
  },

  methods: {
    clearDeckRod: function (event){
      let target = 'prefs.abacus.'
          .concat(event.deck)
          .concat('Rod');

      let default_value = this.$read(target);
      target = event.deck.concat(event.rod);
      this.$refs[target][0].setValue(default_value);
    }
  },

  computed: {
    ...mapGetters([
      'tally',
    ]),
    abacus: function () {
      return this.$read('abacus');
    },
    limits: function () {
      let upper = this.$read('prefs.abacus.upperRod').length;
      let lower = this.$read('prefs.abacus.lowerRod').length;
      return {upper, lower};
    },
  },

  created: function () {
    let upper = this.$read('abacus.upper');
    let lower = this.$read('abacus.lower');

    let i = this.rods;
    while (i) {
      i--;
      if (typeof upper[i] == 'undefined')
        upper[i] = [...this.$read('prefs.abacus.upperRod')];

      if (typeof lower[i] == 'undefined')
        lower[i] = [...this.$read('prefs.abacus.lowerRod')];
    }

    this.$write('abacus.upper', upper);
    this.$write('abacus.lower', lower);
  },

  components: {
    AbacusHelper,
    VueSlider
  },


  // mounted: function (){
  //   setTimeout(()=>{
  //     this.$refs.upper1[0].setValue(1)
  //   }, 5000);
  // }
}
</script>

<style scoped>
.walls {
  height: inherit;

  display: grid;
  grid-auto-flow: row;
  grid-template-rows:
  /*min-content*/
  30px
  75px
  235px;

  grid-gap: 30px;
}

.upper,
.lower {
  display: grid;
  grid-auto-flow: column;
  direction: rtl;
}

.bar {
  margin: 0;
  padding: 20px 0 0 0;
  align-self: center;
}

.bar > * {
  /*align-self: center;*/
  /*justify-self: center;*/
}

.upper > *,
.lower > * {
  justify-self: center;
}

.upper > * {
  align-self: start;
}

.lower > * {
  align-self: end;
}
</style>